'use-strict';

export default function ($) {

    ////////////////////////////////////
    // Functionality for location map widget
    ////////////////////////////////////

    ////////////////////////////////////
    // Methods/vars
    ////////////////////////////////////

    function showPopUp(data, pin) {
        pin.closest('.js-locationMap').find(".c-location-map__popup-text--content").html(decodeURI(data));
        pin.closest('.js-locationMap').find(".c-location-map__popup").addClass('show-popup');
        $("html").addClass("show-map-popup");
    };

    // Control pop up data
    function clearPopUp(context) {
        context.closest('.js-locationMap').find(".c-location-map__popup-text--content").html("");
        context.closest('.js-locationMap').find('.c-location-map__pin.active-pin').removeClass('active-pin');
        context.closest('.js-locationMap').find('.c-location-map__popup').removeClass('show-popup');
        $("html").removeClass("show-map-popup");
    };
    // Generate pop up html
    function generatePopUpHtml(data) {

        var currentData = data;

        let dataString = `<div class="map-data-content">` +
            // Url
            `${currentData.Web !== "" ? `
                <div class="u-fw700">Web</div>
                <div>
                    <a href="${currentData.Web}">${currentData.Web}</a>
                </div>
                <hr />` :
                ""
            }` +
            // Email
            `${currentData.Email !== "" ? `
                <div class="u-fw700">Email</div>
                <div>
                    <a href="mailto:${currentData.Email}">${currentData.Email}</a>
                </div>
                <hr />` :
                ""
            }` +
            // Phone
            `${currentData.Phone !== "" ? `
                <div class="u-fw700">Phone</div>
                <div>${currentData.Phone}</div>
                <hr />` :
                ""
            }` +
            // Address
            `${currentData.Address !== "" ? `
                    <div>
                        <div>
                            ${currentData.Address}
                        </div>
                    </div>` :
                ""
            }
        </div>`;

        var tableString = `
            <table class="c-location-map__popup__table">
                <thead>
                    <th class="u-fw700">Partner</th>
                    <th class="u-fw700">City</th>
                    <th class="u-fw700">Study Area</th>
                </thead>
        `;

        let learnMoreButton = null;
        let anyItems = false;

        data.MapPinDatapoints.forEach(item => {

            let partnerRow = item.PartnerName;
            if (item.partnerNameLink) {
                let partnerLinkNewTab = item.buttonNewTab ? " target='_blank'" : "";
                partnerRow = "<a href='" + item.partnerNameLink + "'" + partnerLinkNewTab + ">" + partnerRow + "</a>";
            }

            let studyAreaRow = item.studyArea;
            if (item.studyAreaLink) {
                let studyAreaLinkNewTab = item.studyAreaLinkNewTab ? " target='_blank'" : "";
                studyAreaRow = "<a href='" + item.studyAreaLink + "'" + studyAreaLinkNewTab + ">" + studyAreaRow + "</a>";
            }

            tableString = tableString + `
                <tr>
                    <td>${partnerRow}</td>
                    <td>${item.duration}</td>
                    <td>${studyAreaRow}</td>
                </tr>
            `
			anyItems = partnerRow != "" || studyAreaRow != "";
        });

        tableString = tableString + '</table>';

        // Hide table if no items to show in it
        if (!anyItems) tableString = "";

        if(currentData.ButtonLink && currentData.ButtonLink.length > 0) {
            let newTab = currentData.ButtonLinkOpenNewTab ? " target='_blank'" : "";
            let text = currentData.ButtonLinkText ? currentData.ButtonLinkText : "Learn More";
            learnMoreButton = "<p style='text-align: center; margin: 0;'><a href='" + currentData.ButtonLink + "'" + newTab + " class='button u-bgc-red text-center u-mt-gutter u-mb-gutter-sm-max' style='padding-top:10px;padding-bottom:10px;font-size:16px;'>" + text + "</a></p>";
        }

        dataString = dataString + tableString;

        // Add heading
        dataString = `<h3 class="title u-fw700 u-mt0">${data.Name}</h3>` + dataString;

        // Add button if there is one
        if (learnMoreButton) {
            dataString += learnMoreButton;
        }

        return dataString;

    }

    function generateMobileHtml(data) {
        var currentData = data,
            html = "";

        for (var i = 0, leng = currentData.length; i < leng; i++) {
            var accordionData = currentData[i].MapLocationDetails,
                location = currentData[i].LocationName,
                subHtml = "";

            for (var ii = 0, lengleng = accordionData.length; ii < lengleng; ii++) {
                var actualData = accordionData[ii];

                subHtml +=
                    `<div class="panel-body collapsible__panel-body">
                        <h3 class="u-mbb3 u-mt0">${actualData.Name}</h3>
                        ${actualData.Web !== "" ? `<p><strong>Web: </strong><a href="${actualData.Web}">${actualData.Web}</a></p>` : ""}
                        ${actualData.Email !== "" ? `<p><strong>Email: </strong><a href="mailto:${actualData.Email}">${actualData.Email}</a></p>` : ""}
                        ${actualData.Phone !== "" ? `<p><strong>Phone: </strong>${actualData.Phone}</p>` : ""}
                        ${actualData.Address !== "" ? `<p>${actualData.Address}</p>` : ""}
                    </div>`;
            }
            html +=
                `<div class="panel panel-default collapsible__parent">
                    <div class="panel-heading collapsible__title" id="location-map-accordion-${i}" role="tab">
                        <div class="o-collapselist__title b-h3">
                            <h3 class="panel-title collapsible__panel-title">
                                <a class="u-link-tdn u-bb0 collapsible__title-link collapsed" role="button" data-toggle="collapse" data-parent="#location-map-accordion"
                                    href="#location-map-accordion-collapse-${i}" aria-expanded="false" aria-controls="location-map-accordion-collapse-${i}">
                                    <span class="u-db u-mbb1">${location}</span>
                                </a>
                            </h3>
                        </div>
                    </div>
                    <div comparison-tab-panel="" class="collapsible__content panel-collapse collapse" id="location-map-accordion-collapse-${i}" role="tabpanel" aria-labelledby="location-map-accordion-${i}" aria-expanded="false">
                        ${subHtml}
                    </div>
                </div>
            `;
        }

        return html;
    }

    // Parse country data
    function parseCountryData(data, $map) {

        var mobileMapImage = data.MobileMap,
            mapData = data.PinLocations;

        // Update the mobile banner image
        $map.find('.c-location-map__mobile-banner-image img').attr('src', mobileMapImage);

        // Sort out the mobile accordions
        $map.find('#location-map-accordion').append(generateMobileHtml(mapData));
        
            
        var allPinDetailsData = [];
        var allCountries = []

        // Sort out the pop up data
        for (var i = 0; i < mapData.length; i++) {

            var location = mapData[i].LocationName,
                count = mapData[i].Children;

            allCountries.push(location);

            mapData[i].MapLocationDetails.forEach(pinData => {
                var marker = `
                    <div class="c-location-map__pin" style="${pinData.Style}" data-location="${pinData.Name}" data-country="${location}" data-popup="${encodeURI(generatePopUpHtml(pinData))}">
                        <div class="location-pin__wrapper">
                            <svg class="location-pin" version="1.1" id="4720" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 41 54" style="enable-background: new 0 0 41 54;" xml:space="preserve">
                                <path class="location-pin-child" style="fill: ${pinData.PinColour}" d="M41,19.6C40.2,8.6,31.2,0,20.5,0S0.8,8.6,0,19.6c-0.3,5,1.3,10,4.4,14l14.7,19.7c0.6,0.8,1.7,1,2.5,0.4 c0.1-0.1,0.3-0.2,0.4-0.4l14.7-19.7C39.7,29.6,41.2,24.6,41,19.6z M20.5,27.8c-4.8,0-8.7-3.8-8.7-8.5c0-4.7,3.8-8.6,8.6-8.6c4.8,0,8.7,3.8,8.7,8.5c0,0,0,0,0,0C29.2,23.9,25.3,27.8,20.5,27.8z"></path>
                            </svg>
                            <span class="location-title ${pinData.ShowPinName === true ? 'show' : ''}" style="${pinData.TextPositionLeft === true ? 'top:3px;left:-58px;bottom:auto;text-align:right;min-width:90px;' : ''} color:${pinData.PinColour};">${pinData.Name}</span>
                            <span class="location-partners ${count === 0 ? 'hidden' : ''}">
                                <span class="location-partners--text">${count}</span>
                            </span>
                        </div>
                    </div>
                `;
                $map.find('.js-locationMap__pins').append(marker);
                var mapPinDatapointsFormatted = pinData.MapPinDatapoints.map(a => {
                    return {
                        ...a,
                        country: pinData.Name,
                        parentCountry: location
                    }
                });
                allPinDetailsData.push(mapPinDatapointsFormatted);
            });

        };

        allPinDetailsData = allPinDetailsData.reduce((a, b) => a.concat(b), []);

        var uniquePartners = [...new Set(allPinDetailsData.map(item => item.PartnerName))];
        var studyAreas = [...new Set(allPinDetailsData.map(item => item.studyArea))];
        
        var uniqueStudyAreas = [...new Set(studyAreas.map(item => {
            const itemVal = extractContent(item.replace(/(\r\n|\n|\r)/gm, ''));
            return itemVal.split('%REPLACE_PLACEHOLDER');
        }).flat())];

        var uniqueCountries = allCountries.map(item => {
            return {
                label: item,
                value: item.replace(/\s/g, '').toLowerCase()
            }
        });

        var allPartners = uniquePartners.map(item => {
            return {
                label: item,
                value: item.replace(/\s/g, '').toLowerCase()
            }
        });

        var formattedUniqueStudyAreas = [...new Set(uniqueStudyAreas.map(a => a.trim()))];
        
        var allStudyAreas = formattedUniqueStudyAreas.map(item => {
            return {
                label: item,
                value: item.replace(/\s/g, '').toLowerCase()
            }
        });

        // Init all filters
        uniqueCountries.forEach(a => {
            $map.find('.js-locationMap__country-filter')[0].insertAdjacentHTML('beforeend',
                `<option value="${a.value}">${a.label}</option>`
            );
        });
        allPartners.forEach(a => {
            if (a.label.length > 0) {
                $map.find('.js-locationMap__partner-filter')[0].insertAdjacentHTML('beforeend',
                    `<option value="${a.value}">${a.label}</option>`
                );
            }
        });
        allStudyAreas.forEach(a => {
            if (a.label.length > 0) {
                $map.find('.js-locationMap__study-area-filter')[0].insertAdjacentHTML('beforeend',
                    `<option value="${a.value}">${a.label}</option>`
                );
            }
        });

        $map.find('.js-locationMap__reset-filters').on('click', function(e) {
            e.preventDefault();
            $map.find('.js-locationMap__country-filter')[0].value = "";
            $map.find('.js-locationMap__partner-filter')[0].value = "";
            $map.find('.js-locationMap__study-area-filter')[0].value = "";
            resetPins();
        });

        $map.find('.js-locationMap__filter').on('click', function(e) {
            e.preventDefault();
            filterPins();
        });

        $map.find('.js-locationMap__filter-toggle').on('click', function(e){
            e.preventDefault();
            $(this).toggleClass('is-active');
        });

        $map.find('.js-locationMap__country-filter, .js-locationMap__partner-filter, .js-locationMap__study-area-filter').on('change', function(){
            optionFilter()
        });

        function extractContent(s) {
            var text = s.replace(new RegExp('<br />', 'g'), '%REPLACE_PLACEHOLDER');
            var span = document.createElement('span');
            span.innerHTML = text;
            return span.textContent || span.innerText;
        };

        function optionFilter() {
            var data = allPinDetailsData;
            console.log(data)
            var countryVal = $map.find('.js-locationMap__country-filter')[0].value;
            var partnerVal = $map.find('.js-locationMap__partner-filter')[0].value;
            var studyAreaVal = $map.find('.js-locationMap__study-area-filter')[0].value;
            if(countryVal.length > 0) {
                data = data.filter(a => {
                    return equaliseString(a.parentCountry) === countryVal
                });
            }
            if(partnerVal.length > 0) {
                data = data.filter(a => {
                    return equaliseString(a.PartnerName) === partnerVal
                });
            }
            if(studyAreaVal.length > 0) {
                data = data.filter(a => {
                    return equaliseString(a.studyArea).includes(studyAreaVal)
                });
            }

            $map.find('.js-locationMap__partner-filter option').each(function(){
                if($(this).val() !== '') {
                    $(this).addClass('hidden')
                }
            });

            $map.find('.js-locationMap__country-filter option').each(function(){
                if($(this).val() !== '') {
                    $(this).addClass('hidden')
                }
            });

            $map.find('.js-locationMap__study-area-filter option').each(function(){
                if($(this).val() !== '') {
                    $(this).addClass('hidden')
                }
            });

            var studyAreas = [...new Set(data.map(item => item.studyArea))];
            var uniqueStudyAreas = [...new Set(studyAreas.map(item => {
                const itemVal = extractContent(item.replace(/(\r\n|\n|\r)/gm, ''));
                return itemVal.split('%REPLACE_PLACEHOLDER');
            }).flat())];

            data.forEach(a => {
                $map.find('.js-locationMap__country-filter option').each(function(){
                    if($(this).val() == equaliseString(a.parentCountry)) {
                        $(this).removeClass('hidden')
                    }
                });
                $map.find('.js-locationMap__partner-filter option').each(function(){
                    if($(this).val() == equaliseString(a.PartnerName)) {
                        $(this).removeClass('hidden')
                    }
                });
                $map.find('.js-locationMap__study-area-filter option').each(function(){
                    if($(this).val() == equaliseString(a.studyArea)) {
                        $(this).removeClass('hidden')
                    }
                });
            });

            uniqueStudyAreas.forEach(a => {
                $map.find('.js-locationMap__study-area-filter option').each(function(){
                    var area = a.trim();
                    if($(this).val() == equaliseString(area)) {
                        $(this).removeClass('hidden')
                    }
                });
            });

            if(studyAreaVal.length == 0 && partnerVal.length == 0) {
                $map.find('.js-locationMap__country-filter option').removeClass('hidden')
            }

        }

        function resetPins() {
            $map.find('.c-location-map__pin').removeClass('hidden');
            $map.find('.c-location-map__popup').removeClass('show-popup');
            $map.find(`.js-locationMap__partner-filter option`).removeClass('hidden');
            $map.find(`.js-locationMap__country-filter option`).removeClass('hidden');
            $map.find(`.js-locationMap__study-area-filter option`).removeClass('hidden');
        }

        function filterPins() {

            $map.find('.c-location-map__pin').removeClass('hidden');
            $map.find('.c-location-map__popup').removeClass('show-popup');

            const countryFilter = $map.find('.js-locationMap__country-filter')[0].value;
            const partnerFilter = $map.find('.js-locationMap__partner-filter')[0].value;
            const studyAreaFilter = $map.find('.js-locationMap__study-area-filter')[0].value;

            if(countryFilter.length == 0 && partnerFilter.length == 0 && studyAreaFilter.length == 0) {
                return;
            }

            if(countryFilter.length > 0) {
                $map.find('.c-location-map__pins').find('.c-location-map__pin').each(function(){
                    const pinCountry = equaliseString($(this).attr('data-country'));
                    if(pinCountry !== countryFilter) {
                        $(this).addClass('hidden');
                    }
                });
            }

            if(partnerFilter.length > 0) {
                const results = allPinDetailsData.filter(a => {
                    return equaliseString(a.PartnerName) === partnerFilter
                });
                $map.find('.c-location-map__pins').find('.c-location-map__pin').each(function(){
                    if($(this).attr('data-location')) {
                        const pinCountry = equaliseString($(this).attr('data-location'));
                        results.forEach(result => {
                            if(pinCountry !== equaliseString(result.country)) {
                                $(this).addClass('hidden');
                            }
                        });
                    }
                });
            }

            if(studyAreaFilter.length > 0) {
                const results = allPinDetailsData.filter(a => {
                    return equaliseString(a.studyArea).includes(studyAreaFilter)
                });
                $map.find('.c-location-map__pins').find('.c-location-map__pin').each(function(){
                    if($(this).attr('data-location')) {
                        const pinCountry = equaliseString($(this).attr('data-location'));
                        const matches = results.filter(item => {
                            return equaliseString(item.country) === pinCountry
                        }).length;
                        if(matches === 0) {
                            $(this).addClass('hidden');
                        }
                    }
                });
            }

        }

    }

    ////////////////////////////////////
    // Set up data
    ////////////////////////////////////
    $(document).ready(function () {
        $('.js-locationMap').each(function(){
            var $map = $(this);
            var path = $map.parent().next('input').val();
            console.log(path)
            $.ajax({
                url: '/api/map',
                method: "GET",
                data: { path: path },
                success: function (response) {
                    parseCountryData(response, $map);
                },
                error: function (response) {
                }
            })
        });
    });



    ////////////////////////////////////
    // Buttons/click
    ////////////////////////////////////
    // Click the pin
    $('.c-location-map')
        .on('click', '.c-location-map__pin', function () {
            showPopUp($(this).data("popup"), $(this));
        })
        .on('click', '.c-location-map__popup-close', function () {
            clearPopUp($(this));
        });

    function equaliseString(string) {
        if(string.length === 0) {
            return ''
        }
        return string.replace(/ /g,"").toLowerCase();
    }

};



// WEBPACK FOOTER //
// ./src/_js/partials/location-map-widget.js